module.exports = __webpack_public_path__ + "static/Matrix-729bc4b8ab54ab664fe47b5efdd246e9.jpg";